import { render } from "./PortfolioView.vue?vue&type=template&id=45882d39"
const script = {}

import exportComponent from "C:\\Users\\gabon\\Desktop\\portfolio-content\\zuzana-gabonayova-portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__